export const getAbValueFromCookie = (issueNumber: string): number | null => {
    if (typeof document === 'undefined') return null
    const cookies = document.cookie.split('; ')
    const abCookie = cookies.find((cookie) =>
        cookie.startsWith(`ab_value_${issueNumber}=`)
    )
    if (!abCookie) return null
    const parsed = parseInt(abCookie.split('=')[1], 10)
    return Number.isNaN(parsed) || parsed < 0 || parsed > 9 ? null : parsed
}

export const setAbValueToCookie = (issueNumber: string, value: number): void => {
    if (typeof document === 'undefined') return
    document.cookie = `ab_value_${issueNumber}=${value}; path=/; max-age=31536000`
}
